import { Controller } from "@hotwired/stimulus"
import Swal from "sweetalert2"

export default class extends Controller {
  static values = {
    title: String,
    text: String,
    icon: String
  }

  confirm(event) {
    event.preventDefault()
    const el = this.element

    Swal.fire({
      title: this.titleValue || "Tem certeza?",
      text: this.textValue || "Essa ação não pode ser desfeita.",
      icon: this.iconValue || "warning",
      showCancelButton: true,
      confirmButtonText: "Sim",
      cancelButtonText: "Cancelar"
    }).then(result => {
      if (result.isConfirmed) {
        if (el.tagName === "FORM") {
          el.requestSubmit()
        } else if (el.closest("form")) {
          el.closest("form").requestSubmit()
        } else if (el.tagName === "A") {
          this.submitLinkAsPost(el)
        }
      }
    })
  }

  submitLinkAsPost(link) {
    const form = document.createElement("form")
    form.method = "POST"
    form.action = link.href

    const csrf = document.querySelector('meta[name="csrf-token"]')
    if (csrf) {
      const token = document.createElement("input")
      token.type = "hidden"
      token.name = "authenticity_token"
      token.value = csrf.content
      form.appendChild(token)
    }

    const methodInput = document.createElement("input")
    methodInput.type = "hidden"
    methodInput.name = "_method"
    methodInput.value = link.dataset.method || "post"
    form.appendChild(methodInput)

    document.body.appendChild(form)
    form.submit()
  }
}
